module.exports = __webpack_public_path__ + "img/222A0436.9117df24.png";